import React, { FunctionComponent } from "react";
import Box, { BoxProps } from "@mui/material/Box";
import html from "csi/html";

export interface RichTextProps extends Omit<BoxProps, "children"> {
	/** HTML content */
	value: string;
}

const RichText: FunctionComponent<RichTextProps> = (props) => {
	const { value, ...otherProps } = props;
	const richText = html.returnRichText(value);

	return (
		<Box
			dangerouslySetInnerHTML={{ __html: richText }}
			{...otherProps}
		/>
	);
};

export default RichText;